import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import {
  isPublicAuthRequest,
  isUnauthorizedHttpError,
} from '../utils/http-auth.util';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        isUnauthorizedHttpError(error) &&
        !isPublicAuthRequest(req.url)
      ) {
        auth.handleSessionExpired();
      }

      return throwError(() => error);
    }),
  );
};
